"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destroy = exports.createOrUpdate = exports.findOrCreate = exports.update = exports.create = exports.findBy = exports.findById = void 0;
var configure_1 = require("./configure");
function getQueryDocumentSnapshotById(collectionName, resourceId) {
  return __awaiter(this, void 0, void 0, function () {
    var collection, queryResult;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, (0, configure_1.getCollection)(collectionName)];
        case 1:
          collection = _a.sent();
          return [4 /*yield*/, collection.where('id', '==', resourceId).limit(1).get()];
        case 2:
          queryResult = _a.sent();
          if (queryResult.docs.length === 0) {
            return [2 /*return*/, null];
          }
          return [2 /*return*/, queryResult.docs[0]];
      }
    });
  });
}
/**
 * Get a resource by its id
 * @param {string} collectionName name of the firestore collection
 * @param {ResourceStoreId} resourceId id of the resource we want fin
 * @return {Promise<ResourceStoreRecord | null>} a promise that resolves to the resource if it exists or null
 */
function findById(collectionName, resourceId) {
  return __awaiter(this, void 0, void 0, function () {
    var queryDocumentSnapshot;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, getQueryDocumentSnapshotById(collectionName, resourceId)];
        case 1:
          queryDocumentSnapshot = _a.sent();
          if (queryDocumentSnapshot === null) {
            return [2 /*return*/, null];
          }
          return [2 /*return*/, queryDocumentSnapshot.data()];
      }
    });
  });
}
exports.findById = findById;
/**
 * Get a list of resources that match a query
 * @param {ResourceStoreFindByArguments} args where {string} collectionName and {FirestoreQuery} queries are required, {number} pageLimit and {ResourceStoreId} startAfter are used for pagination
 * @return {Promise<ResourceStoreRecord[]>} a Promise that resolves to an array containing all resources that match queries
 */
function findBy(_a) {
  var collectionName = _a.collectionName,
    queries = _a.queries,
    orderBy = _a.orderBy,
    hardLimit = _a.hardLimit,
    pageLimit = _a.pageLimit,
    startAfter = _a.startAfter;
  return __awaiter(this, void 0, void 0, function () {
    var collection, combinedQuery, queryResult;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, (0, configure_1.getCollection)(collectionName)];
        case 1:
          collection = _b.sent();
          combinedQuery = collection;
          queries.forEach(function (query) {
            combinedQuery = combinedQuery.where(query.field, query.operand, query.value);
          });
          if (hardLimit) {
            // if there is a hardLimit, we'll only return that many records
            combinedQuery = combinedQuery.limit(hardLimit);
          } else if (pageLimit) {
            // if there is a pageLimit, we are paginating
            // by default, order by the `id` field
            combinedQuery = combinedQuery.orderBy.apply(combinedQuery, orderBy || ['id']);
            // startAfter is not there for the first page
            // startAfter shouldn't be 0 or the empty string either from the second page onward
            if (startAfter) {
              combinedQuery = combinedQuery.startAfter(startAfter);
            }
            combinedQuery = combinedQuery.limit(pageLimit);
          }
          return [4 /*yield*/, combinedQuery.get()];
        case 2:
          queryResult = _b.sent();
          return [2 /*return*/, queryResult.docs.map(function (doc) {
            return doc.data();
          })];
      }
    });
  });
}
exports.findBy = findBy;
/**
 * Creates a resource in the resource store
 * @param {string} collectionName name of the firestore collection
 * @param {ResourceStoreRecord} resource must at least contain the id field
 */
function create(collectionName, resource) {
  return __awaiter(this, void 0, void 0, function () {
    var existingQueryDocumentSnapshot, collection;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, getQueryDocumentSnapshotById(collectionName, resource.id)];
        case 1:
          existingQueryDocumentSnapshot = _a.sent();
          if (!(existingQueryDocumentSnapshot === null)) return [3 /*break*/, 4];
          return [4 /*yield*/, (0, configure_1.getCollection)(collectionName)];
        case 2:
          collection = _a.sent();
          return [4 /*yield*/, collection.add(resource)];
        case 3:
          _a.sent();
          return [3 /*break*/, 5];
        case 4:
          throw new Error("Cannot create: Resource with id " + resource.id + " already exists");
        case 5:
          return [2 /*return*/];
      }
    });
  });
}

exports.create = create;
/**
 * Updates a resource in the resource store
 * @param {string} collectionName name of the firestore collection
 * @param {ResourceStoreRecord} resource must contain the id field to get the one we want to update
 */
function update(collectionName, resource) {
  return __awaiter(this, void 0, void 0, function () {
    var queryDocumentSnapshot;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, getQueryDocumentSnapshotById(collectionName, resource.id)];
        case 1:
          queryDocumentSnapshot = _a.sent();
          if (!(queryDocumentSnapshot === null)) return [3 /*break*/, 2];
          throw new Error("Cannot update: Resource with id " + resource.id + " does not exist");
        case 2:
          return [4 /*yield*/, queryDocumentSnapshot.ref.update(resource)];
        case 3:
          _a.sent();
          _a.label = 4;
        case 4:
          return [2 /*return*/];
      }
    });
  });
}

exports.update = update;
/**
 * Find a resource by its id or create if it doesn't exist
 * @param {string} collectionName name of the firestore collection
 * @param {ResourceStoreRecord} resource content of the resource we want to find or create, must at least contain the id field
 */
function findOrCreate(collectionName, resource) {
  return __awaiter(this, void 0, void 0, function () {
    var queryDocumentSnapshot, collection, createdResource;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, getQueryDocumentSnapshotById(collectionName, resource.id)];
        case 1:
          queryDocumentSnapshot = _a.sent();
          if (!(queryDocumentSnapshot === null)) return [3 /*break*/, 5];
          return [4 /*yield*/, (0, configure_1.getCollection)(collectionName)];
        case 2:
          collection = _a.sent();
          return [4 /*yield*/, collection.add(resource)];
        case 3:
          _a.sent();
          return [4 /*yield*/, findById(collectionName, resource.id)];
        case 4:
          createdResource = _a.sent();
          return [2 /*return*/, createdResource];
        case 5:
          return [2 /*return*/, queryDocumentSnapshot.data()];
      }
    });
  });
}
exports.findOrCreate = findOrCreate;
/**
 * Update a resource with new values or create if it doesn't exist
 * @param {string} collectionName name of the firestore collection
 * @param {ResourceStoreRecord} resource content of the resource we want to create or update, must at least contain the id field
 */
function createOrUpdate(collectionName, resource) {
  return __awaiter(this, void 0, void 0, function () {
    var queryDocumentSnapshot, collection;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, getQueryDocumentSnapshotById(collectionName, resource.id)
          // create the resource if it's not there
          ];

        case 1:
          queryDocumentSnapshot = _a.sent();
          if (!(queryDocumentSnapshot === null)) return [3 /*break*/, 4];
          return [4 /*yield*/, (0, configure_1.getCollection)(collectionName)];
        case 2:
          collection = _a.sent();
          return [4 /*yield*/, collection.add(resource)];
        case 3:
          _a.sent();
          return [3 /*break*/, 6];
        case 4:
          // update existing resource
          return [4 /*yield*/, queryDocumentSnapshot.ref.update(resource)];
        case 5:
          // update existing resource
          _a.sent();
          _a.label = 6;
        case 6:
          return [2 /*return*/];
      }
    });
  });
}

exports.createOrUpdate = createOrUpdate;
/**
 * Destroy a resource
 * @param {string} collectionName name of the firestore collection
 * @param {ResourceStoreId} resourceId id of the resource we want to destroy
 */
function destroy(collectionName, resourceId) {
  return __awaiter(this, void 0, void 0, function () {
    var queryDocumentSnapshot;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, getQueryDocumentSnapshotById(collectionName, resourceId)];
        case 1:
          queryDocumentSnapshot = _a.sent();
          if (!(queryDocumentSnapshot !== null)) return [3 /*break*/, 3];
          return [4 /*yield*/, queryDocumentSnapshot.ref.delete()];
        case 2:
          _a.sent();
          _a.label = 3;
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.destroy = destroy;